import { useDispatch } from 'react-redux';
import { useState, useEffect } from 'react';

import { setConnectionLost } from 'store/uiEffects/actions';

import useModals from 'modals/hooks';

import { ModalName } from 'modals/types';

const useNetworkStatus = () => {
    const [isOnline, toggleNetworkStatus] = useState(window.navigator.onLine);

    const dispatch = useDispatch();

    const { openModal, closeModal } = useModals();

    useEffect(() => {
        isOnline ? closeModal() : openModal(ModalName.NoConnectionModal);

        dispatch(setConnectionLost(!isOnline));
    }, [isOnline, openModal, closeModal, dispatch]);

    useEffect(() => {
        const onNetworkStatusChange = () => toggleNetworkStatus((prev) => !prev);

        window.addEventListener('online', onNetworkStatusChange);
        window.addEventListener('offline', onNetworkStatusChange);

        return () => {
            window.removeEventListener('online', onNetworkStatusChange);
            window.removeEventListener('offline', onNetworkStatusChange);
        };
    }, []);

    return isOnline;
};

export { useNetworkStatus };
